import type { QueryClient } from '@tanstack/react-query';

import type { TUseDocumentResult } from '@modules/documents';
import type { TUseFileResult } from '@modules/files';
import type { TItemType } from '../types/items.types';

const invalidateFolderCardStatusQueries = (queryClient: QueryClient, itemId: string, itemType: TItemType) => {
  if (itemType !== 'DOCUMENT' && itemType !== 'FILE') return;

  const queryKey = `${itemType.toLowerCase()}-${itemId}`;
  const item =
    itemType === 'DOCUMENT'
      ? queryClient.getQueryData<TUseDocumentResult>([queryKey])?.doc
      : queryClient.getQueryData<TUseFileResult>([queryKey])?.file;
  const rootId = item?.resolvedPath[0]?._id;

  queryClient.invalidateQueries({ queryKey: ['products'] });
  if (rootId) queryClient.invalidateQueries({ queryKey: [`folder-${rootId}`] });
};

export default invalidateFolderCardStatusQueries;
